import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LoadingScreen({ onComplete }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(false), 1500);
    const t2 = setTimeout(() => onComplete(), 2100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#141414]"
          data-testid="loading-screen"
        >
          <div className="flex flex-col items-center gap-4">
            <svg viewBox="0 0 240 130" className="w-52 h-28" fill="none">
              <motion.path
                d="M 15 95 Q 60 25 120 65 Q 180 105 225 35"
                stroke="#C1440E"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 0.7 }}
                transition={{ duration: 1.0, ease: "easeInOut" }}
              />
              <motion.text
                x="62"
                y="92"
                fontFamily="'Cormorant Garamond', serif"
                fontSize="76"
                fontWeight="600"
                fill="#D4A843"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.5, ease: "easeOut" }}
              >
                77
              </motion.text>
              <motion.line
                x1="60"
                y1="105"
                x2="180"
                y2="105"
                stroke="#D4A843"
                strokeWidth="0.8"
                strokeLinecap="round"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ delay: 0.8, duration: 0.5 }}
                style={{ transformOrigin: "120px 105px" }}
              />
            </svg>
            <motion.p
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.0, duration: 0.4 }}
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300, letterSpacing: "0.35em" }}
              className="text-[#D4A843]/70 text-xs uppercase"
            >
              Art meets Party
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
